import { v4 as uuidv4 } from "uuid";
import type { BaseBlock } from "@circle-react-shared/BuilderUI/DataModel.types";
import {
  getMarginOptions,
  getPaddingOptions,
} from "@circle-react-shared/BuilderUI/utils/boxModelStyleHelpers";
import {
  getColorOptions,
  getFontPickerOptions,
  getFontSizeOptions,
  getFontStyleOptions,
  getFontWeightOptions,
  getLineHeightOptions,
  getTextAlignOptions,
  getTextDecorationOptions,
  getTextTransformOptions,
} from "@circle-react-shared/BuilderUI/utils/textStyleHelpers";
import { p3DefaultStyles } from "./defaultStyles";

export const p3DefaultData: BaseBlock = {
  id: uuidv4(),
  type: "p",
  props: {
    text: {
      prop: "other",
      type: "textarea",
      value: "Paragraph text",
    },
    paragraphStyle: {
      prop: "other",
      type: "paragraph-style-picker",
      value: "p3",
    },
    styles: {
      prop: "styles",
      type: "styles",
      value: {
        color: getColorOptions(p3DefaultStyles.color),
        textTransform: getTextTransformOptions(p3DefaultStyles.textTransform),
        fontStyle: getFontStyleOptions(p3DefaultStyles.fontStyle),
        fontWeight: getFontWeightOptions(p3DefaultStyles.fontWeight),
        fontSize: getFontSizeOptions(p3DefaultStyles.fontSize),
        fontFamily: getFontPickerOptions(p3DefaultStyles.fontFamily),
        lineHeight: getLineHeightOptions(p3DefaultStyles.lineHeight),
        textAlign: getTextAlignOptions(p3DefaultStyles.textAlign),
        textDecoration: getTextDecorationOptions(
          p3DefaultStyles.textDecoration,
        ),
        margin: getMarginOptions({
          defaultValue: p3DefaultStyles.margin,
        }),
        padding: getPaddingOptions({
          defaultValue: p3DefaultStyles.padding,
        }),
      },
    },
  },
};
